import React from "react";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";
import Urunlerimiz from "../Components/urunlerimiz/Urunlerimiz";
import useSEO from "../seo/useSEO";

function UrunlerimizPage() {
  useSEO({
    title: "Özel Üretim CNC Parçaları | Aypin Otomat",
    description:
      "Aypin Otomat özel üretim civata, pim, pirinç parça ve burç çözümlerini inceleyin. CNC kayar otomat ve talaşlı imalat ile özel parça üretimi.",
    path: "/urunlerimiz",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Ürünlerimiz",
        path: "/urunlerimiz",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer2 />
      <Urunlerimiz />
    </>
  );
}

export default UrunlerimizPage;